import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f230abe4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "navbar-custom navbar-light sticky-top mb-0"
}
const _hoisted_2 = { class: "superior" }
const _hoisted_3 = { href: "/" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_6 = { class: "nombre-evento-custom m-0 text-uppercase" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sign-out-alt fa-2x text-white" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "inferior navbar-nav"
}
const _hoisted_10 = { class: "nav-item active" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-lg-inline" }, "1. ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-lg-inline" }, "2. ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-lg-inline" }, "3. ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-none d-lg-inline" }, "4. ", -1))
const _hoisted_15 = { class: "mt-5" }
const _hoisted_16 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_17 = ["src"]

import { useStore } from 'vuex'
import { key } from '@/setup/store'
import { VuexStore } from '@/interfaces/VuexStore'
import { useI18n } from 'vue-i18n'
import useLogout from '@/composables/useLogout'
import { RouterLink } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  __name: 'AppSideBarComponent',
  setup(__props) {

const { state, getters } = useStore<VuexStore>(key)
const { t } = useI18n()
const { logOut } = useLogout()

return (_ctx: any,_cache: any) => {
  return (_unref(state).evento)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("a", _hoisted_3, [
              _createElementVNode("img", {
                class: "logo",
                src: _unref(state).evento.logo
              }, null, 8, _hoisted_4)
            ]),
            (!_unref(state).evento?.fidelizacion)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("h4", _hoisted_6, _toDisplayString(_unref(state).evento.nombre), 1)
                ]))
              : _createCommentVNode("", true),
            (!_unref(getters).isLogin)
              ? (_openBlock(), _createBlock(_unref(RouterLink), {
                  key: 1,
                  class: "d-block d-lg-none text-decoration-none fw-bold text-white",
                  to: "/login"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" INGRESAR ")
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: "d-block d-lg-none",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(logOut)()))
                }, _hoisted_8))
          ]),
          (!_unref(state).evento.fidelizacion)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                _createElementVNode("li", _hoisted_10, [
                  _createVNode(_unref(RouterLink), {
                    class: _normalizeClass(["nav-link fw-bold", !_unref(getters).isComplete ? '' : 'disabled']),
                    to: _unref(getters).actualUbicacionURL
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11,
                      _createTextVNode(_toDisplayString(!_unref(state).evento.fidelizacion ? _unref(t)('menu.item1') : 'Categorias'), 1)
                    ]),
                    _: 1
                  }, 8, ["to", "class"])
                ]),
                _createElementVNode("li", {
                  class: _normalizeClass(["nav-item", 
            _unref(getters).actualActividadURL.hasOwnProperty('name') ? 'active' : ''
          ])
                }, [
                  _createVNode(_unref(RouterLink), {
                    class: _normalizeClass(["nav-link fw-bold", 
              _unref(getters).actualActividadURL.hasOwnProperty('name') &&
              !_unref(getters).isComplete
                ? ''
                : 'disabled'
            ]),
                    to: _unref(getters).actualActividadURL
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12,
                      _createTextVNode(_toDisplayString(_unref(t)('menu.item2')), 1)
                    ]),
                    _: 1
                  }, 8, ["to", "class"])
                ], 2),
                _createElementVNode("li", {
                  class: _normalizeClass(["nav-item", _unref(getters).resumenURL.hasOwnProperty('name') ? 'active' : ''])
                }, [
                  _createVNode(_unref(RouterLink), {
                    class: _normalizeClass(["nav-link fw-bold", 
              _unref(getters).actualFormularioURL.hasOwnProperty('name') &&
              !_unref(getters).resumenURL.hasOwnProperty('name') &&
              !_unref(getters).isComplete
                ? ''
                : 'disabled'
            ]),
                    to: _unref(getters).actualFormularioURL
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13,
                      _createTextVNode(_toDisplayString(_unref(t)('menu.item3')), 1)
                    ]),
                    _: 1
                  }, 8, ["to", "class"])
                ], 2),
                _createElementVNode("li", {
                  class: _normalizeClass(["nav-item", _unref(getters).resumenURL.hasOwnProperty('name') ? 'active' : ''])
                }, [
                  _createVNode(_unref(RouterLink), {
                    class: _normalizeClass(["nav-link fw-bold", 
              _unref(getters).resumenURL.hasOwnProperty('name') && !_unref(getters).isComplete
                ? ''
                : 'disabled'
            ]),
                    to: _unref(getters).resumenURL
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14,
                      _createTextVNode(_toDisplayString(_unref(t)('menu.item4')), 1)
                    ]),
                    _: 1
                  }, 8, ["to", "class"])
                ], 2)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          (!_unref(getters).isLogin)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_unref(RouterLink), {
                  class: "link-login-custom nav-link text-center fw-bold text-uppercase d-none d-lg-block",
                  to: "/login"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('menu.item5')), 1)
                  ]),
                  _: 1
                }),
                (_unref(state).evento.fidelizacion && !_unref(state).evento.porInvitacion)
                  ? (_openBlock(), _createBlock(_unref(RouterLink), {
                      key: 0,
                      class: "link-login-custom nav-link text-center fw-bold text-uppercase d-none d-lg-block",
                      to: {name: 'Register'}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Registrarme ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_unref(state).evento.fidelizacion)
                  ? (_openBlock(), _createBlock(_unref(RouterLink), {
                      key: 0,
                      to: {name: 'MiCuenta'},
                      class: "nav-link fw-bold text-uppercase d-none d-lg-block",
                      style: {"cursor":"pointer"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Mi cuenta ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "nav-link fw-bold text-uppercase d-none d-lg-block",
                  style: {"cursor":"pointer"},
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(logOut)()))
                }, _toDisplayString(_unref(t)('menu.item6')), 1)
              ], 64))
        ]),
        (_unref(state).evento.emblema)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("img", {
                height: "35",
                src: _unref(state).evento.emblema,
                class: "fallback",
                alt: ""
              }, null, 8, _hoisted_17)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})